import { useEffect } from "react";
import { subscribeToChatNotifications } from "../../services/chatNotifications";

const ChatNotificationsListener = ({ userId }) => {
  useEffect(() => {
    if (!userId) return undefined;
    return subscribeToChatNotifications(userId);
  }, [userId]);

  return null;
};

export default ChatNotificationsListener;
